export default __webpack_public_path__ + "static/media/ToyotaType-Book.87223662.eot";